export default {
    workFlow: {
        run: 'Run',
        timeRun: 'Scheduler',
        nodeDesc: 'Please enter the node description',
        config: 'Config',
        historyRecord: 'History Record',
        deleteNode: 'The node will not be restored after deletion, are you sure you want to delete it?',
        deleteNodeBtn: 'Confirm Delete',
        nodeContent: 'Please enter the node content',
        pleaseInput: 'Please input',
        pleaseUpload: 'Please upload',
        input: 'input',
        select: 'Select',
        please: 'Please',
        pleaseInputNodeName: 'Please enter the node name',
        insertVariable: 'Insert Variable',
        noNode: 'No node',
        copy: 'Copy',
        delete: 'Delete',
        deleteNodeTitle: 'Delete Node',
        addSubParameter: 'Add Sub Parameter',
        array: 'Array',
        object: 'Object',
        professionalFunction: 'Team Function, see',
        professionalFunctionDesc: 'Team Function, see',
        upgradeToVersion: 'Upgrade to {version} Version',
        versionDescription: 'Version Description',
        nodeInput: 'Node Input ',
        nodeInputLabel: 'Node Input',
        nodeInputDesc: 'Node input is the output of the previous node, you can add other node variables or custom text',
        lastNode: 'Last Node',
        unknownNodeOutput: 'Unknown Node Output',
        branchNode: 'Branch Node',
        basicNode: 'Basic Node',
        individualityNode: 'Individuality Node',
        imageInputDesc: 'When the image input setting of the start node is selected as "Need to input both image and text", the input is the user\'s question for image recognition, which is the text input of the start node by default',
        createWorkFlow: 'Create workflow',
        copyWorkFlowTemplate: 'Create from Template',
        workFlowName: 'Name',
        pleaseInputWorkFlowName: 'Enter workflow name',  
        workFlowDesc: 'Description',
        pleaseInputWorkFlowDesc: 'Enter workflow description',
        workFlowAvatar: 'Avatar',
        aiGenerate: 'AI Generate',
        workFlowCategory: 'Category',
        pleaseSelectCategory: 'Select category',
        pleaseVisitPC: 'Please visit on PC to ensure display effect',
        imageUploadSupport: 'Image upload only supports jpeg,png format',
        imageSizeLessThan5MB: 'Image size must be less than 5MB!',
        copyWorkFlowConfirm: 'Will automatically create a same workflow, confirm copy?',
        copySuccess: 'Copy Success',
        workflowCopy: 'Copy Workflow ',
        deleteWorkFlowConfirm: 'Are you sure you want to delete the current workflow?',
        deleteWorkFlow: 'Delete Workflow',
        deleteSuccess: 'Delete Success',
        pleaseUploadWorkFlowAvatar: 'Please upload the workflow avatar',
        pleaseSelectCategoryWarn: 'Please select category!',
        startDialog: 'Start Chat',

        AppNode: {
            appTip: 'App ',
            memoryTip: 'Memory ',
            memoryTipDesc: 'The higher the temperature, the more creative and uncertain the reply, the lower the temperature, the more rigorous the reply',
            memoryTipDesc1: 'When enabled, the node will use the memory of the workflow, otherwise it will use the memory of the application itself (set in the application configuration).',
            memoryTipDesc2: 'The workflow\'s memory refers to the input of the start node and the output of the end node in each run (excluding the content in the middle).',
            memoryTipDesc3: 'The memory content may have been processed by multiple nodes unrelated to this node, please select whether to enable it based on actual needs.',
            pleaseSelectMemoryTurn: 'Please select the memory turn',
            memoryTurn: 'Turn',
        },
        ChannelNode:{
            selectChannel: 'Select Channel ',
            supportChannel: 'Support WeChat and Enterprise WeChat托管渠道',
            hostingChannel: 'Hosting Channel',
            WebhookSend: 'Webhook Send',
            clientTip: 'Client ',
            sendPerson: 'Send Person ',
            sendType: 'Send Type ',
            singleChat: 'Single Chat',
            groupChat: 'Group Chat',
            receiver: 'Receiver',
            loading: 'Loading',
            edit: 'Edit',
            more: 'More',
            pleaseFill: 'Please fill in',
            configDesc: 'Configuration Instructions',
            pleaseInputName: 'Enter the name to search',
            search: 'Search',
            headImg: 'Head Image',
            name: 'Name',
            dialogApp: 'Dialog Application',
            dingTalk: 'DingTalk Group Robot',
            feiShu: 'FeiShu Group Robot',
            weWork: 'WeWork Group Robot',
            dingTalkTip: 'Please add a custom robot to the DingTalk group and get the Webhook address ',
            feiShuTip: 'Please add a custom robot to the FeiShu group and get the Webhook address ',
            weWorkTip: 'Please add a group robot to the WeWork internal group and get the Webhook address ',
            dingTalkTip1: 'DingTalk group robot security settings select "add signature", and get the key ',
            feiShuTip1: 'FeiShu group robot security settings select "signature verification", and get the key ',
            pleaseSelectSender: 'Please select the sender',
            pleaseSelectClient: 'Please select the client',
            pleaseSelectSendType: 'Please select the send type',
        },
        CodeNode: {
            variableInput: 'Variable Input',
            pleaseInputParameter: 'Please input parameter',
            addParameter: 'Add Parameter',
            codeBlock: 'Code Block',
            variableOutput: 'Variable Output',
            pleaseInputName: 'Please input the name',
            editCode: 'Edit Code',
            codeLogic: 'The following is the code logic, pay attention to indentation',
        },
        DatabaseNode: {
            databaseTitle: 'Database ',
            databaseDesc: 'The database node needs to be followed by a "Large Model" node to process the query result',
            pleaseCreateDatabase: 'Please create a database first',
        },
        EndNode:{
            outputVoice: 'Output Voice ',
            replyStrategy: 'Reply Strategy ',
            replySplit: 'Reply Split',
            queryMerge: 'Query Merge',
            delayReply: 'Delay Reply',
            delayReplyTime: 'Delay Reply Time',
            replySplitTip: 'For long content, it will be randomly split into multiple segments for reply',
            queryMergeTip: 'For multiple questions within a short period of time, the content will be summarized and replied at once. This feature requires setting the "Delay Reply" time below to take effect',
            delayReplyTip: 'Extra delay time before content generation and reply',
            second: 'Second',
            playFail: 'Play failed, please contact the administrator',
        },
        FixedReplyNode: {
            fixedReplyTitle: 'Fixed Content',
        },
        IntentNode: {
            modelTitle: 'Model',
            memoryTip: 'Memory',
            memoryTipDesc: 'The higher the temperature, the more creative and uncertain the reply, the lower the temperature, the more rigorous the reply',
            memoryTipDesc1: 'The workflow\'s memory refers to the input of the start node and the output of the end node in each run (excluding the content in the middle).',
            memoryTipDesc2: 'The memory content may have been processed by multiple nodes unrelated to this node, please select whether to enable it based on actual needs.',
            pleaseSelectMemoryTurn: 'Please select the memory turn',
            memoryTurn: 'Turn',
            branch: 'Branch',
            defaultBranch: 'Default Branch',
            branchName: 'Branch Name',
            branchDesc: 'Please describe in detail what conditions to execute this branch',
            addBranch: 'Add Branch',
        },
        KnowLedgeBaseNode: {
            knowLedgeBaseTitle: 'Knowledge',
            pleaseCreateKnowledgeBase: 'Please create a knowledge base first',
            knowLedgeBaseTip: 'Knowledge base nodes need to be followed by a "Large Model" node to process the search results, rather than an "App" node',
            searchMode: 'Search Mode ',
            semanticRetrieval: 'Semantic Retrieval',
            hybridSearch: 'Hybrid Search',
            semanticRetrievalTip: 'Search for related text through semantic vectors',
            hybridSearchTip: 'Search for related text through semantic vectors and full text (keywords)',
            similarityThreshold: 'Similarity Threshold ',
            similarityThresholdTip: 'Only knowledge base entries with a similarity higher than this threshold will be retrieved. You can test this in "Knowledge Base - Search Test":',
            similarityThresholdTip1: 'When the similarity is high (such as 0.8 or above), only the knowledge related to the question will be retrieved, which will be more accurate but also more likely to miss.',
            similarityThresholdTip2: 'When the similarity is low (such as 0.7 or below), it may retrieve content with low relevance, but the search range will be larger.',
            semanticRetrievalCount: 'Semantic Retrieval Count ',
            semanticRetrievalCountTip: 'The maximum number of paragraphs retrieved from the knowledge base in a single question, default is 3. Increasing the number will increase token consumption, and note that it should not exceed the model\'s maximum context.',
            fullTextRetrievalCount: 'Full Text Retrieval Count ',
            fullTextRetrievalCountTip: 'The maximum number of paragraphs retrieved from the knowledge base in a single question, default is 1. Increasing the number will increase token consumption, and note that it should not exceed the model\'s maximum context.',    
            fullTextRetrievalCountTip1: '1. The sum of the full text retrieval count and the semantic retrieval count is up to 10, and the semantic retrieval count setting is prioritized.',
            fullTextRetrievalCountTip2: '2. If there is no matching keyword in actual use, the actual result of the enhanced full text retrieval may be 0.',
            max: 'Max',
        },
        LlmNode: {
            systemPrompt: 'System Prompt ',
            systemPromptTip: 'System prompt is very important, it determines the character setting, function and working characteristics of the robot, please describe it as detailed as possible in natural language, the more specific the better.',
            temperatureTitle: 'Temperature ',
            temperatureTip: 'The higher the temperature, the more creative and uncertain the reply, the lower the temperature, the more rigorous the reply',
            modelTitle: 'Model',
            pleaseSelectModel: 'Please select the model',
            generalModel: 'General Large Model',
            industryModel: 'Industry Large Model',
            memoryTitle: 'Memory ',
            memoryTip: 'The higher the temperature, the more creative and uncertain the reply, the lower the temperature, the more rigorous the reply',
            memoryTipDesc1: '1. The workflow\'s memory refers to the input of the start node and the output of the end node in each run (excluding the content in the middle).',
            memoryTipDesc2: '2. The memory content may have been processed by multiple nodes unrelated to this node, please select whether to enable it based on actual needs.',
            pleaseSelectMemoryTurn: 'Please select the memory turn',
            memoryTurn: 'Turn',
            jsonFormatTitle: 'Structured Output ',
            jsonFormatTip: 'Structured Output Variable',
            outputVariableStructure: 'Output Variable Structure ',
            pleaseInputParameter: 'Please input parameter',
            pleaseSelectType: 'Please select type',
            string: 'String',
            number: 'Number',
            pleaseInputName: 'Please input the name',
            addOutput: 'Add Output',
            variableStructureRepeat: 'Variable structure has duplicate code',
        },
        LogicBranchNode: {
            branchTitle: 'Branch ',
            defaultBranch: 'Default Branch',
            branch: 'Branch',
            pleaseInputBranchName: 'Please input the branch name',
            branchName: 'Branch Name',
            branchDesc: 'Please describe in detail what conditions to execute this branch',
            addCondition: 'Add Condition',
            addBranch: 'Add Branch',
            and: 'And',
            or: 'Or',
            condition: 'Condition',
            value: 'Value',
            Option: {
                contains: 'Contains',
                not_contains: 'Not Contains',
                eq: 'Equal',
                neq: 'Not Equal',
                empty: 'Empty',
                not_empty: 'Not Empty',
                pre_contains: 'Pre Contains',
                post_contains: 'Post Contains',
            }
        },
        ManualNode: {
            defaultReply: 'Default Reply ',
            pleaseInputDefaultReply: 'Please input default reply',
            noticeUser: 'Notice User ',
            noticeMethod: 'Notice Method ',
            replyMode: 'Reply Mode ',
            pleaseSelectNoticeUser: 'Please select notice user',
            sms: 'SMS',
            wechatMp: 'WeChat MP',
            replyModeTip: 'After switching to manual, there are three modes to choose from',
            replyModeTip1: 'No reply: After switching to manual, you need to manually switch to AI reply in the "Dialog Management" module',
            replyModeTip2: 'Continue reply: After switching to manual, AI will continue to reply',
            replyModeTip3: 'Delay reply: After switching to manual, it will automatically switch to AI reply after a specified delay time',
            pleaseSelectReplyMode: 'Please select reply mode',
            delayReply: 'Delay Reply ',
            delayReplyTip: 'Extra delay time before content generation and reply',
            delay: 'Delay',
            pleaseEnter: 'Please enter ',
            minutes: 'minutes later automatically switch back to AI reply',
            strategyReply: {
                noReply: 'After switching to manual, it will not reply',
                continueReply: 'After switching to manual, AI will continue to reply',
                delayReply: 'After switching to manual, it will delay reply after a specified time',
            }
        },
        PluginNode: {
            fillParamEntity: 'Model Filling',
            structureParameterTitle: 'Structure Parameter ',
            structureParameterTip: 'After enabling, the plugin\'s structured request and response will be used',
            requestParameter: 'Request Parameter ',
            requestParameterTip: 'The request parameters defined in the plugin, which can be filled in with fixed text or inserted variables',
            imageInputTitle: 'Image Input ',
            imageInputTip: 'Image input of the start node',
            fileInputTitle: 'File Input ',
            fileInputTip: 'File input of the start node',
            pluginTitle: 'Plugin ',
            pluginTip: 'The result of the plugin needs to be processed into natural language before being passed on to the next node, usually followed by a "Large Model" node to process the data',
            modelTitle: 'Model ',
            imageModel: 'Image Recognition Model ',
            imageModelTip: 'Identify and understand images, answer user questions',
            viewDetails: 'View details',
            priceDocument: 'Price Document',
            responseResultTitle: 'Response Result ',
            responseResultTip: 'The response data returned by the plugin can be referenced by the subsequent node',
            customPlugin: 'Custom Plugin',
            builtinPlugin: 'Built-in Plugin',
            array: 'Array',
            object: 'Object',
            defaultFile: 'Default File',
            defaultText: 'Default Text',
            defaultImage: 'Default Image',  
            fileOutputType: 'File Output Type',
            fileName: 'File Name',
            wordDocument: 'Word',
            excelTable: 'Excel',
            pleaseInputFileName: 'Enter file name',
            fileGenerateResult: 'File name',
        },
        StartNode: {
            inputConfig: 'Input Config',
            textInput: 'Text Input',
            imageInput: 'Image Input',
            fileInput: 'File Input',
            textInputTip: 'User default text question',
            imageInputTip: 'User uploaded or sent image (can be used in image recognition plugin node)',
            fileInputTip: 'Fill in the application name and description, and let AI help you generate other content. Note that for key configurations such as \'app settings\', it is recommended to optimize them after filling in to achieve better results.',
            customVariable: 'Custom Variable',
            addCustomVariable: 'Add Variable',
            parameterSetting: 'Parameter Setting',
            variableType: 'Variable Type',
            variableName: 'Variable Display Name',
            pleaseInputVariableName: 'Please input the variable display name',
            versionDescription: 'Version Description',
            variable: 'Variable',
            variableTip: 'Define the unique identifier of the variable, the system will identify and use the variable based on the identifier, and it cannot be changed after confirmation',
            variableTip1: 'Support English, numbers, and underscores "_"',
            isRequired: 'Is Required',
            inputPrompt: 'Input Prompt',
            inputPromptTip: 'Text prompt for user input',
            channelRunCondition: 'Channel Run Condition',
            channelRunConditionTip1: 'When the workflow is used with a hosted channel, if "Need to input both image and text" is selected, the user\'s question needs to be sent with an image first and then with text to trigger the workflow;',
            channelRunConditionTip2: 'if "Only input image" is selected, sending an image will trigger the workflow',
            needInputImageAndText: 'Need to input both image and text', 
            onlyInputImage: 'Only input image',
            option: 'Option',
            optionTip: 'Please enter the option name',
            addOption: 'Add Option',
            optionDefaultValue: 'Option Default Value',
            defaultInput: 'Default Input',
            pleaseInputDefault: 'Please input default',
            defaultImage: 'Default Image',
            defaultFile: 'Default File',
            text: 'Text',
            image: 'Image',
            file: 'File',
            defaultText: 'Default Text',
            variableRepeat: 'Variable repeat, please check and adjust',
            pleaseAddOption: 'Please add option',
            optionEmpty: 'Option cannot be empty',
            pleaseSelectDefault: 'Please select default',
            deleteVariableTip: 'Deleting a variable may cause the node that references this variable to malfunction, please check and delete after confirming it is correct!',
            deleteVariable: 'Delete Variable',
            fileSizeLessThan15MB: 'File size must be less than 15MB!',
            versionFeatures: 'Version Features,',
            seeDetails: 'See Details',
            singleChoice: 'Radio',
            systemVariable: 'Variable',
        },
        TimeNode: {
            cronRule: 'Cron Rule',
            createRule: 'Create Rule',
            cronSetting: 'Cron Setting',
            nodeInputTitle: 'Node Input',
            nodeInputContent: 'Workflow start node input content for scheduled execution',
            smartGeneration: 'Smart Generation',
            cronExpression: 'Cron Expression',
            howToWrite: 'How to write ',
            CronExpression: 'cron timing rule expression?',
            describeCronRule: 'Use natural language to describe the time rule of the scheduled task',
            generateCron: 'Generate Cron',
            exampleOne: 'Example One ',
            exampleTwo: 'Example Two ',
            exampleOneContent: 'Every morning at 8 o\'clock',
            exampleTwoContent: 'Every morning at 9 o\'clock and 18 o\'clock on Monday to Friday',
            pleaseInputCronExpression: 'Please input 5-character cron expression',
            preview: 'Preview',
            cronPreview: 'Cron Preview:',
            cronExpressionTitle: 'Cron Expression ',
            pleaseInputYourCronExpression: 'Please input your cron expression',
            last10ExecutionTime: 'Last 10 Execution Time ',
            nodeInputCannotBeEmpty: 'Node input cannot be empty',
            cronExpressionCannotBeEmpty: 'Cron expression cannot be empty',
            saveSuccess: 'Save Success',
            confirmClearCronRule: 'Are you sure you want to clear the cron rule?',
            clearCronRule: 'Clear Cron Rule',
            confirmDeleteCronTask: 'Are you sure you want to delete the cron task?',
            deleteCronTask: 'Delete Cron Task',
            deleteSuccess: 'Delete Success',
        },
        checkNode: {
            pleaseSelectModel: 'Please select model',
            pleaseInputBranchName: 'Please input branch name',
            noConnectBranch: 'No connect branch',
            pleaseAddBranchCondition: 'Please add branch condition',
            pleaseSetBranchCondition: 'Please set branch condition',
            pleaseSelectKnowledgeBase: 'Please select knowledge base',
            pleaseSelectApp: 'Please select app',
            pleaseSelectPlugin: 'Please select plugin',
            pleaseInputDefaultReply: 'Please input default reply',
            pleaseSelectDatabase: 'Please select database',
            pleaseSelectClient: 'Select client',
            pleaseSelectSender: 'Please select sender',
            pleaseSelectSendType: 'Please select send type',
            pleaseSelectReceiver: 'Please select receiver',
            pleaseFillWebhookUrl: 'Please fill webhook_url',
            pleaseFillWebhookSecret: 'Please fill webhook_secret',
            alreadyContainsStartNode: 'Already contains a start node',
            alreadyContainsEndNode: 'Already contains an end node',
        },
        nodeConfig: {
            start: 'Start',
            end: 'End',
            app: 'Agent',
            appDesc: 'Use the created lightweight application or knowledge application to generate content',
            llm: 'LLM',
            llmDesc: 'Call large language model, and generate reply with system prompt',
            knowledgeBase: 'Knowledge',
            knowledgeBaseDesc: 'Select a specific knowledge base, search the knowledge base based on the input content, and output the result',
            database: 'Database',
            databaseDesc: 'Perform read and write operations on the database',
            plugin: 'Plugin',
            pluginDesc: 'Use built-in plugins or custom plugins to perform tasks',
            code: 'Code',
            codeDesc: 'Write Python or JavaScript code to process input parameters and output results',
            intentBranch: 'Intent Branch',
            intentBranchDesc: 'Through intent recognition, determine the subsequent flow branch based on the input content',
            logicBranch: 'Logic Branch',
            logicBranchDesc: 'Logic judgment based on the value of the input variable to select the subsequent flow branch',
            fixedReply: 'Fixed Content',
            fixedReplyDesc: 'Output the set fixed content',
            channelSend: 'Channel Send',
            channelSendDesc: 'Send content to the selected channel',
            manual: 'Manual',
            manualDesc: 'Directly execute the dialog "Manual" and send a reminder',
        },
        nodeDefault: {
            intentBranch: 'Intent Branch',
            defaultBranch: 'Default Branch',
            defaultBranchDesc: 'Other intentions will default to this branch when not hit',
            start: 'Start',
            defaultText: 'Default Text',
            defaultImage: 'Default Image',
            defaultFile: 'Default File',
            end: 'End',
            fixedReply: 'Fixed Content',
            llm: 'LLM',
            app: 'Agent',
            knowledgeBase: 'Knowledge',
            database: 'Database',
            plugin: 'Plugin',
            code: 'Code',
            logicBranch: 'Logic Branch',
            defaultLogicBranch: 'Default Branch',
            channelSend: 'Channel Send',
            codeBlock: 'Code Block',
            manual: 'Manual',
            defaultOutput: 'Default Output',
            codeLogic: 'The following is the code logic, pay attention to indentation',
        },
        detail: 'Details',
        runSuccess: 'Run Success',
        runFailed: 'Run Failed',
        returnList: 'Return List',
        startRun: 'Start Run',
        saveSuccess: 'Save Success',
        knowledgeBase: 'Knowledge',
        knowledgeHitCount: 'Knowledge Hit Count ',
        contextCount: 'Context Count ',
        question: 'Question ',
        answer: 'Answer ',
        sqlStatement: 'SQL ',
        executionStatus: 'Execution Status ',
        output: 'Output ',
        branchSelection: 'Branch Selection ',
        executionSuccess: 'Execution Success',
        executionFailed: 'Execution Failed',
        noExecution: 'No Execution',
        inputTip: 'Input ',
        nodeRun: 'Node Run ',
        singleNodeRunInput: 'Single Node Run Input',
        fullFlowRunInput: 'Full Flow Run Input',
        pleaseSelect: 'Please Select',
        image: 'Image',
        ChatContextClearedSuccessfully: 'Chat Context Cleared Successfully',
        imageUploadFailed: 'Image Upload Failed',
        fileSizeLessThan15MB: 'File size must be less than 15MB!',
        pleaseConnectEndNode: 'Please connect end node',
        variableDoesNotExist: 'Variable does not exist',
        nodeContentC: 'Node Content',
        saveFailed: 'Save Failed',
        pleaseEnterTheFlowName: 'Enter the flow name',
        pleaseEnterTheFlowDescription: 'Enter the flow description',
        pleaseUploadImage: 'Please upload image',
        pleaseSelectGroup: 'Please select group',
        modifySuccess: 'Modify Success',
        official: 'LinkAi',
        imageUploadOnlySupportJpegPngFormat: 'Image upload only supports jpeg,png format',
        publishSuccess: 'Publish Success!',
        goToDialog: 'Go chat',
        cancelPublish: 'Are you sure you want to cancel the flow publishing to the square?',
        cancelPublishConfirm: 'Cancel Publish',
        closeSuccess: 'Close Success',
        closeFailed: 'Close Failed, please try again',
        clock: 'Scheduler',
        runTo: 'Run',
        running: 'Running',
        save: 'Save',
        saveLoading: 'Saving',
        publish: 'Publish',
        publishSquare: 'Publish Square',
        displayOnAppSquare: 'After enabling, the latest saved version of the workflow can be found and used in the square',
        channelAccess: 'Channel Access',
        apiCall: 'API Call',
        access: 'Access',
        officialWebsite: 'Portal',
        document: 'Docs',
        editFlow: 'Edit Workflow',
        cancel: 'Cancel',
        confirm: 'Confirm'
    }
}